import { L } from 'harmony-language';
import React from 'react';
import { OrgQueryKeys } from '../../../api/config';
import { useAddOrganizationResourceMutation } from '../../../api/mutations/add/use-add-organization-resource-mutation';
import { useEditOrganizationResourceMutation } from '../../../api/mutations/edit/use-edit-organization-resource-mutation';
import { useLocationTypes } from '../../../api/queries/use-location-types';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import { type EditCreateComponentProps, type LocationTypeColor } from '../../../types';
import { ResourcePage } from '../resource-page';
import { EditCreateLocationTypeColor } from './edit-create-location-type-color';
import { useLocationTypeColorColumns } from './use-location-type-color-columns';

export const LocationTypeColorManagement = () => {
    const { data: locationTypeColors, isLoading } = useOrganizationQuery<LocationTypeColor[]>(OrgQueryKeys.locationTypeColors);
    const { data: locationTypes = [] } = useLocationTypes();
    const { mutateAsync: addLocationTypeColor, isLoading: isCreating } = useAddOrganizationResourceMutation(OrgQueryKeys.locationTypeColors, L.locationTypeColor());
    const { mutateAsync: editLocationTypeColor, isLoading: isUpdating } = useEditOrganizationResourceMutation(OrgQueryKeys.locationTypeColors, L.locationTypeColor());
    const columns = useLocationTypeColorColumns();

    return (
        <ResourcePage
            resourceType='locationTypeColor'
            isLoading={isLoading || isCreating || isUpdating}
            titleFunc={(locationTypeColor: LocationTypeColor) => locationTypes.find(type => type.id === locationTypeColor.organizationLocationTypeId)?.name}
            data={locationTypeColors}
            columns={columns}
            EditCreateComponent={(editCreateProps: EditCreateComponentProps<LocationTypeColor>) =>
                <EditCreateLocationTypeColor
                    existingLocationTypeColor={editCreateProps.resource}
                    locationTypes={locationTypes}
                    closeModal={editCreateProps.closeModal}
                    addLocationTypeColor={addLocationTypeColor}
                    editLocationTypeColor={editLocationTypeColor}
                />
            }
        />
    );
}